module.exports = __webpack_public_path__ + "img/homegnome.4397cf69.svg";